import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';

/**
 * @subcomponent SecondaryTile
 * @deprecated Use Standard Tile instead, which provides a better user experience.
 */ const SecondaryTilePrice = deprecatedComponent({
    displayName: 'SecondaryTilePrice',
    description: 'SecondaryTilePrice is deprecated; use Standard Tile instead, which provides a better user experience.',
    root: createComponent({
        displayName: 'SecondaryTilePrice',
        root: 'div',
        propConfig: {
            classNames: [
                'swan-secondary-tile-price'
            ]
        }
    })
});

export { SecondaryTilePrice };
